
<div class="flex flex-col gap-6 min-w-[30vw] min-h-40">
  <div class="w-full flex flex-col gap-4">
    @if (!!localData) {
      <div class="flex gap-4 items-center">
        <div class="flex flex-col gap-2 w-full">
          <label class="font-semibold">Unit Code<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></label>
          <input type="text" pInputText [(ngModel)]="localData.code" [disabled]="!!modalData()?.code" />
        </div>
        <div class="flex flex-col gap-2 w-full">
          <label class="font-semibold">Unit Name<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></label>
          <input type="text" pInputText [(ngModel)]="localData.name" />
        </div>
      </div>
      <label class="font-semibold">Status</label>
      <div class="flex gap-2 items-center">
        <p-tag severity="secondary" rounded value="Inactive"  />
        <p-toggleswitch [(ngModel)]="localData.active" [disabled]="!hasUnitDetails" />
        <p-tag severity="info" rounded value="Active"  />
      </div>
      <div class="w-full h-[1px] bg-surface-200 my-2"></div>
      <label class="font-semibold">Unit Manager</label>
      <p-autocomplete data-testid="unit-manager-input"
                      [formControl]="managerControl"
                      [dropdown]="true"
                      [suggestions]="filteredManagers"
                      (completeMethod)="filterManagers($event)"
                      (onSelect)="setManager()"
                      (onClear)="clearManager()"
                      [showClear]="true"
                      [disabled]="!hasUnitDetails"
                      forceSelection
                      optionLabel="name"
                      placeholder="Enter name..."
                      appendTo="body"
                      class="w-1/2"
                      size="small">
      </p-autocomplete>
      <label class="font-semibold">Acting Unit Manager</label>
      <div class="flex flex-col w-full gap-2 items-start">
        <div class="flex w-full gap-2 items-center">
          <p-autocomplete data-testid="unit-acting-manager-input"
                          [formControl]="actingManagerControl"
                          [dropdown]="true"
                          [suggestions]="filteredActingManagers"
                          (completeMethod)="filterActingManagers($event)"
                          (onSelect)="setActingManager()"
                          (onClear)="clearActingManager()"
                          [showClear]="true"
                          [disabled]="!hasUnitDetails || !hasManager"
                          forceSelection
                          optionLabel="name"
                          placeholder="Enter name..."
                          appendTo="body"
                          class="w-1/2"
                          size="small">
          </p-autocomplete>
          <p-button
            size="small"
            severity="danger"
            [disabled]="!hasUnitDetails || !localData.actingManager"
            (click)="clearActingManager()"
          ><span class="text-xs">Remove</span></p-button>
        </div>

        <span>until</span>
        <p-datepicker [(ngModel)]="actingToDate"
                      [disabled]="!hasUnitDetails || !hasManager || !localData.actingManager"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      [dateFormat]="'dd/mm/y'"
                      [readonlyInput]="true"
                      [minDate]="today"
                      placeholder="DD/MM/YY"
                      size="small"
                      appendTo="body"
                      showClear>
        </p-datepicker>
      </div>
      <div class="w-full h-[1px] bg-surface-200 my-2"></div>
      <label class="font-semibold">Unit Approvers</label>
      <p-autocomplete data-testid="unit-approver-input"
                      [formControl]="approverControl"
                      [dropdown]="true"
                      [suggestions]="filteredApprovers"
                      (completeMethod)="filterApprovers($event)"
                      (onSelect)="addApprover()"
                      [disabled]="!hasUnitDetails"
                      forceSelection
                      optionLabel="name"
                      placeholder="Type/Select name to add..."
                      appendTo="body"
                      class="w-1/2"
                      size="small">
      </p-autocomplete>
      <p><i>These Unit Approvers can approve travel funding for any project in this unit.</i></p>
      <label class="font-semibold">Current Approvers</label>
      <div data-testid="unit-approvers-list" class="flex flex-wrap gap-4 max-w-[600px]">
        @for (approver of localData.approvers; let ii = $index; track approver.id) {
          <div class="flex gap-2 items-center">
            <span>{{approver.name}}</span>
            <icon-btn variant="close-red" (click)="removeApprover(ii)" />
          </div>
        } @empty {
          <div class="pl-1"><i>No current approvers.</i></div>
        }
      </div>
    }
  </div>

  <div class="w-full h-[1px] bg-surface-200 px-4"></div>
  <div class="flex justify-end gap-2">
    <p-button
      size="small"
      label="Save"
      severity="primary"
      icon="fa-regular fa-save"
      [disabled]="!canSave"
      (click)="saveDialog()"
    />
    <p-button
      size="small"
      label="Cancel"
      severity="danger"
      icon="fa-regular fa-cancel"
      (click)="closeDialog()"
    />
  </div>
</div>
